import React from 'react'
import { GridLoader } from "react-spinners";
import { COLORS } from '../constants/colors';
export const Loading = () => {
  return (
   <div style={{display:"flex", alignItems:"center", justifyContent:"center", marginTop:"20%"}}>
              <GridLoader
        color={COLORS.BRAND_PRIMARY}
        loading={true}
        size={40}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
      </div>
  )
}
